var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPrint(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.535,
    height: 20,
    viewBox: "0 0 21.535 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-print-1537788",
    transform: "translate(-82.647 -68.318)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17361",
    "data-name": "Path 17361",
    d: "M143.612,74.986a2.91,2.91,0,0,0-2.91-2.91h-2.646V68.848a.529.529,0,0,0-.529-.529h-9.365a.529.529,0,0,0-.529.529v3.228h-2.646a2.91,2.91,0,0,0-2.91,2.91v6.032a2.91,2.91,0,0,0,2.91,2.91h2.381V87.79a.529.529,0,0,0,.529.529h9.894a.529.529,0,0,0,.529-.529V83.927H140.7a2.91,2.91,0,0,0,2.91-2.91Zm-14.921-5.608H137v2.7h-8.307Zm-.265,17.91V80.144h8.836v7.116Zm14.127-6.27a1.852,1.852,0,0,1-1.852,1.852h-2.381V80.144h1.4a.529.529,0,0,0,0-1.058H125.967a.529.529,0,0,0,0,1.058h1.4v2.725h-2.381a1.852,1.852,0,0,1-1.852-1.852V74.986a1.852,1.852,0,0,1,1.852-1.852H140.7a1.852,1.852,0,0,1,1.852,1.852Z",
    transform: "translate(-39.431)",
    fill: "#3b4452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17362",
    "data-name": "Path 17362",
    d: "M434.124,205.52h-2.949a.536.536,0,0,0,0,1.072h2.949a.536.536,0,0,0,0-1.072Z",
    transform: "translate(-333.508 -130.724)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17363",
    "data-name": "Path 17363",
    d: "M313.017,355.554h2.493a.536.536,0,0,0,0-1.072h-2.493a.536.536,0,0,0,0,1.072Z",
    transform: "translate(-220.862 -272.655)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17364",
    "data-name": "Path 17364",
    d: "M300.343,410.48h-4.128a.536.536,0,0,0,0,1.072h4.128a.536.536,0,1,0,0-1.072Z",
    transform: "translate(-204.865 -326.048)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPrint);
export default __webpack_public_path__ + "static/media/IconPrint.cbf900e54d3f86054c1a527fa6bd2140.svg";
export { ForwardRef as ReactComponent };